/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const initialState = {
  performDisputeResolutionObj: {},
  planType: [],
  rebateProgram: [],
  errorMsgPaymentSummary: [],
  rebateProgramName: {},
  quarterFrom: '',
  quarterTo: '',
  paymentSummary: [],
  reportOption: [],
  timePeriod: [],
  dramsInvoice: [],
  stateFiscal: [],
  selectedYear: 'Calender',
  QuarterOption: '',
  selectedOption: 'Payment Date Range',
  beginDate: '',
  federalBeginDateDRAMS: '',
  stateBeginDateDRAMS: '',
  displayObj: {
    rebateProgramName: {},
    quarterFrom: '',
    quarterTo: '',
    paymentSummary: [],
    reportOption: [],
    timePeriod: [],
    selectedYear: 'Calender',
    QuarterOption: '',
    selectedOption: 'Payment Date Range',
    beginDate: '',
    federalBeginDateDRAMS: '',
    stateBeginDateDRAMS: '',
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPLAY_OBJ:
      return { ...state, performResolutionObj: action.screenData };

    case actionTypes.GET_CURRENT_DISPLAY_DETAIL_OBJ:
      return { ...state, resolutionDetailObj: action.detailScrData };
    case actionTypes.GET_DISPLAY_DATES:
      return { ...state, ...action.payload };
    case actionTypes.SET_DISPLAY_OBJ_PAYMENT:
      const tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.GET_ERROR_MSG_PAYMENT_SUMMARY:
      return { ...state, errorMsgPaymentSummary: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_NAME:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.GET_PAYMENT_SUMMARY:
      const displayObj = {
        ...state.displayObj,
        paymentSummary: action.payload,
      };
      return { ...state, paymentSummary: action.payload, displayObj };

    case actionTypes.DISPLAY_REPORT_OPTION:
      return { ...state, QuarterOption: action.payload };
    case actionTypes.DISPLAY_TIME_PERIOD:
      return { ...state, selectedOption: action.payload };
    case actionTypes.GET_FROM_PAYMENT:
      return { ...state, quarterFrom: action.payload };
    case actionTypes.GET_TO_PAYMENT:
      return { ...state, quarterTo: action.payload };
    case actionTypes.DISPLAY_YEAR:
      return { ...state, selectedYear: action.payload };
    case actionTypes.GET_DRAMS_INVOICE_START_QUARTER_VALUE:
      return { ...state, dramsInvoice: action.payload };
    case actionTypes.DISPLAY_STATE_FISCAL:
      return { ...state, stateFiscal: action.payload };
    case actionTypes.SET_REFRESH_DATA:
      return {
        ...state,
        performDisputeResolutionObj: {},
        planType: [],
        rebateProgram: [],
        errorMsgPaymentSummary: [],
        rebateProgramName: {},
        quarterFrom: '',
        quarterTo: '',
        paymentSummary: [],
        reportOption: [],
        timePeriod: [],
        dramsInvoice: [],
        stateFiscal: [],
        selectedYear: 'Calender',
        QuarterOption: '',
        selectedOption: 'Payment Date Range',
        beginDate: '',
        federalBeginDateDRAMS: '',
        stateBeginDateDRAMS: '',
      };
    case actionTypes.SET_REFRESH_DATA_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    default:
      return state;
  }
};

export default reducer;
